import React, { useEffect, useState } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "axios";
import { environment } from "../../environment";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Swal from "sweetalert2";
import { type } from "os";
import NavbarNew from "../Components/NavbarNew";

const { SearchBar } = Search;

const Tickets = (history) => {
  const [data, setData] = useState([]);
  const [ticketURL, setTicketURL] = useState("");

  useEffect(() => {
    let ticketUrl = environment.dap_url + "support/getAllActiveSupports";
    let user = JSON.parse(localStorage.getItem("user"));
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let isPartner = localStorage.getItem("isPartnerLogin");
    if (localStorage.getItem("isItExecutive")) {
      ticketUrl =
        environment.dap_url +
        "support/getAllActiveSupports?id=" +
        user.createdById +
        "&execId=" +
        user._id;
    } else if (localStorage.getItem("isSupportAdmin")) {
      ticketUrl =
        environment.dap_url +
        "support/getAllActiveSupports?id=" +
        user.createdById;
    } else if (isPartner) {
      ticketUrl =
        environment.dap_url + "support/getAllActiveSupports?id=" + user._id;
    }
    console.log("authority", userDetails.data.authority == "SYS_ADMIN");
    if (userDetails.data.authority == "SYS_ADMIN") {
    }

    setTicketURL(ticketUrl);
    getTickets(ticketUrl);
  }, []);

  const getTickets = (url) => {
    axios
      .get(url)
      .then((response) => {
        console.log(response.data);
        const temp = [];
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  const deleteTicket = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "support/delete?id=" + id)
          .then((res) => {
            if (res) {
              Swal.fire({
                icon: "success",
                title: "Ticket Deleted",
                showConfirmButton: false,
                timer: 1500,
              }).then((result) => {
                // handleCancel();
                // history.push("/supports");
                // window.location.reload();
                setData([]);
                console.log(ticketURL);
                getTickets(ticketURL);
              });
            }
          });
      }
    });
  };

  const actions = (ticketId) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>
            <LinkContainer
              to={`/supports/ticket/edit/?ticketid=${ticketId}`}
              style={{
                background: "#FFDD33",
                color: "white",
                radius: "50px",
              }}
            >
              <Button variant="light" className="btn-sm">
                <span class="typcn typcn-edit"></span>
              </Button>
            </LinkContainer>
          </div>
          <div>
            <LinkContainer
              to={`/supports/ticket/view/?ticketid=${ticketId}`}
              style={{
                background: "blue",
                color: "white",
                radius: "50px",
              }}
            >
              <Button variant="light" className="btn-sm">
                <span class="typcn typcn-eye-outline"></span>
              </Button>
            </LinkContainer>
          </div>
          <div>
            <LinkContainer
              to={`/supports/ticket/delete/?ticketid=${ticketId}`}
              style={{
                background: "red",
                color: "white",
                radius: "50px",
              }}
            >
              <Button variant="light" className="btn-sm">
                <span class="typcn typcn-trash"></span>
              </Button>
            </LinkContainer>
          </div>
        </div>
      </>
    );
  };

  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (row, col, rowIndex, formatExtra) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "createdAt",
      text: "Date",
      formatter: (dataField) => {
        return dataField.split("T")[0];
      },
    },
    {
      dataField: "ticketId",
      text: "Ticket Id",
    },
    {
      dataField: "customer_details",
      text: "Customer Name",
      formatter: (dataField) => {
        if (dataField.length > 0) {
          return dataField[0].userFirstName + " " + dataField[0].userLastName;
        } else {
          return "";
        }
      },
    },
    {
      dataField: "priority",
      text: "Priority",
    },
    {
      dataField: "excutive_details",
      text: "Assigned To",
      formatter: (dataField) => {
        if (dataField.length > 0) {
          return dataField[0].userFirstName + " " + dataField[0].userLastName;
        } else {
          return "";
        }
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (dataField) => {
        if (dataField == "close") {
          return "Closed";
        }
        return dataField;
      },
    },
    {
      dataField: "_id",
      text: "Action",
      formatter: (row, cell, rowIndex, formatter) => {
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <LinkContainer to={`/supports/ViewTicket/` + cell._id}>
                <Button variant="primary" className="btn-sm">
                  <i className="fa fa-eye"></i>
                </Button>
              </LinkContainer>
            </div>
            <div>
              <LinkContainer to={`/supports/editTicket/` + cell._id}>
                <Button
                  variant="info"
                  className="btn-sm"
                  disabled={cell.status == "closed" ? true : false}
                >
                  <i className="fa fa-edit"></i>
                </Button>
              </LinkContainer>
            </div>
            <div>
              <Button
                variant="danger"
                className="btn-sm"
                onClick={(e) => {
                  deleteTicket(cell._id);
                }}
                disabled={cell.status == "closed" ? true : false}
              >
                <i className="fa fa-trash"></i>
              </Button>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="container-fluid">
      <NavbarNew />
      <LinkContainer
        to={`/supports/createticket`}
        style={{
          float: "right",

          background: "#5271FF",
          marginBottom: "20px",
          color: "white",
          radius: "8px",
        }}
      >
        <Button variant="light" className="btn-lg">
          New Ticket
        </Button>
      </LinkContainer>
      <div className="row">
        <h4 className="card-title">TICKETS</h4>
      </div>
      <ToolkitProvider
        keyField="id"
        bootstrap4
        data={data}
        columns={columns}
        search
      >
        {(props) => (
          <div>
            <div className="d-flex align-items-center">
              <p className="mb-2 mr-2">Search in table:</p>
              <SearchBar {...props.searchProps} />
            </div>
            <BootstrapTable
              defaultSorted={defaultSorted}
              pagination={paginationFactory()}
              {...props.baseProps}
              wrapperClasses="table-responsive"
            />
          </div>
        )}
      </ToolkitProvider>
      {/* <BootstrapTable keyField='id' data={data} columns={columns} /> */}
    </div>
  );
};

export default Tickets;
